"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildRequestTrackingInterceptor = void 0;
const commons_logs_1 = require("@deliverr/commons-logs");
const buildRequestTrackingInterceptor = () => {
    return async (requestConfig) => {
        const trackingHeaders = Object.assign(Object.assign(Object.assign({}, getHeaderFromContext(commons_logs_1.ContextUtilsKeys.X_REQUEST_ID)), getHeaderFromContext("X-Request-Caller")), getHeaderFromContext("X-System-Trace-Ids"));
        Object.entries(trackingHeaders).forEach(([key, value]) => {
            requestConfig.headers[key] = value;
        });
        return requestConfig;
    };
};
exports.buildRequestTrackingInterceptor = buildRequestTrackingInterceptor;
const getHeaderFromContext = (headerId) => {
    return commons_logs_1.contextUtils.getContext(headerId) ? { [headerId]: commons_logs_1.contextUtils.getContext(headerId) } : {};
};
//# sourceMappingURL=buildRequestTrackingInterceptor.js.map